module.exports = __webpack_public_path__ + "static/media/Ariel Noah.609ae894.jpg";